import {Injectable} from '@angular/core'
import {AuthStatusService} from './auth-status.service'
import {AuthService} from './auth.service'

@Injectable()
export class AuthServerService extends AuthService {
  constructor(private authStatusService: AuthStatusService) {
    super()
    this.sendNoAuthStatus()
  }

  completeSignInChallenge(email: string, answer: string): Promise<void> {
    return Promise.resolve(undefined)
  }

  signIn(email: string): Promise<void> {
    return Promise.resolve(undefined)
  }

  signOut(): Promise<void> {
    return Promise.resolve(undefined)
  }

  private sendNoAuthStatus() {
    this.authStatusService.sendAuthStatusUpdate({
      isLoading: false,
      authenticatedUser: undefined,
    })
  }
}
